import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";

export const useDeleteTraineesMembersMutation = () => {
  return useMutation(InternalStudyListService.removeTrainess);
};
